interface PulsingBorderProps {
  isFocused?: boolean;
  children: React.ReactNode;
}

export function PulsingBorder({ isFocused = false, children }: PulsingBorderProps) {
  return (
    <div className="relative">
      {/* Outer container with padding for the glow effect */}
      <div className="relative p-[2px] rounded-[14px]">
        {/* Animated gradient border */}
        <div
          className="absolute inset-0 rounded-[14px] pointer-events-none"
          style={{
            background: `linear-gradient(
              90deg,
              rgba(31, 71, 136, 0) 0%,
              rgba(31, 71, 136, 0.4) 15%,
              rgba(59, 130, 246, 0.7) 30%,
              rgba(147, 197, 253, 0.9) 40%,
              rgba(233, 30, 99, 1) 50%,
              rgba(156, 39, 176, 0.9) 60%,
              rgba(59, 130, 246, 0.7) 70%,
              rgba(31, 71, 136, 0.4) 85%,
              rgba(31, 71, 136, 0) 100%
            )`,
            backgroundSize: '200% 100%',
            animation: 'border-glow-travel 6s linear infinite',
            opacity: isFocused ? 1 : 0.6,
            transition: 'opacity 0.3s ease-in-out',
          }}
        />

        {/* Pulsing glow layer */}
        <div
          className="absolute inset-0 rounded-[14px] pointer-events-none"
          style={{
            boxShadow: isFocused
              ? '0 0 20px rgba(233, 30, 99, 0.4), 0 0 40px rgba(156, 39, 176, 0.3), 0 0 60px rgba(59, 130, 246, 0.2), inset 0 0 20px rgba(233, 30, 99, 0.1)'
              : '0 0 10px rgba(31, 71, 136, 0.4), 0 0 20px rgba(156, 39, 176, 0.2)',
            animation: 'pulse-intensity 5.2s ease-in-out infinite',
            transition: 'box-shadow 0.3s ease-in-out',
          }}
        />

        {/* Children content */}
        <div className="relative z-10">
          {children}
        </div>
      </div>
    </div>
  );
}
